import * as action from '../../actions/gdprAdsV3/advertisingOptionsActions';
import AdvertisingGdprV3ViewState from '../../store/schema/AdvertisingGdprV3ViewState';
import saveGdprAdsV3OptionOrchestrator from '../../orchestrators/gdprAdsV3/saveAdvertisingOptionOrchestrator';
import { calculateCookieTargeting, setGdprFirstPartyCookieOptInBit } from 'owa-cookie-targeting';
import { getOptionsStore } from '../../store/Store';
import { orchestrator } from 'satcheljs';

orchestrator(action.toggleFirstPartyCookieOption, () => {
    const store = getOptionsStore();
    const viewState = store.activeViewState as AdvertisingGdprV3ViewState;

    if (viewState.selectedVendorId?.indexOf(2) > -1) {
        setGdprFirstPartyCookieOptInBit(2);
    } else if (viewState.selectedVendorId?.indexOf(3) > -1) {
        setGdprFirstPartyCookieOptInBit(3);
    }

    calculateCookieTargeting();
    saveGdprAdsV3OptionOrchestrator(store);
});
